<ng-template
  #cardTemplate
  let-highlight="highlight"
  let-title="title"
  let-plan="plan"
  let-price="price"
  let-period="period"
  let-duration="duration"
  let-badge="badge"
  let-buttonText="buttonText"
  let-buttonIsShow="buttonIsShow"
  let-buttonDisabled="buttonDisabled"
  let-monthlyPrice="monthlyPrice"
  let-planId="planId"
>
  <div
    class="text-md leading-4 w-full shrink bg-white rounded-2xl px-7 py-9 md:p-9 shadow-black-whisper relative border-2 border-border-line"
    [class.highlight-glow]="highlight"
  >
    <div class="flex flex-col items-center gap-6 mx-auto md:max-w-screen-xs">
      <div class="tracking-widest font-bold text-yellow-gold-darker whitespace-nowrap">{{ title }}</div>
      <div class="font-bold text-base">
        <span *ngIf="plan === 3" class="mr-1">短期集中</span>
        <span class="text-[1.5em] -mr-[0.1em]">{{ plan }}</span>
        ヶ月プラン
      </div>
      <div class="font-bold text-3xl -mr-4">
        <strong class="tracking-wide -mr-1">¥ {{ price }}</strong>
        <span class="text-xs ml-2">(税込)</span>
      </div>
      <!--      <div-->
      <!--        *ngIf="showPriceRevisionNotice && (plan === 6 || plan === 12)"-->
      <!--        class="text-[12px] text-info-700 leading-snug tracking-normal -mt-2"-->
      <!--      >-->
      <!--        <span *ngIf="plan === 6">※価格改定以降のお申込みは、<strong class="font-bold">¥6,600（税込）</strong>となります。</span>-->
      <!--        <span *ngIf="plan === 12">※価格改定以降のお申込みは、<strong class="font-bold">¥8,800（税込）</strong>となります。</span>-->
      <!--      </div>-->
      <div
        class="bg-white border border-border-line rounded-lg w-full divide-border-line divide-y text-sm [&>div]:min-h-8 [&>div]:flex [&>div]:items-center [&>div]:justify-between [&>div]:px-2 tracking-widest"
      >
        <div *ngIf="period">
          <div class="font-bold mx-auto">{{ period }}</div>
        </div>
        <div *ngIf="monthlyPrice">
          <div class="text-xs text-black/50">ひと月あたり</div>
          <div>
            <span class="font-bold text-base">￥{{ monthlyPrice }}</span>
            <span class="text-xs tracking-normal">(税込)</span>
          </div>
        </div>
        <div>
          <div class="text-xs text-black/50">サービス利用開始から</div>
          <div>{{ duration }}</div>
        </div>
      </div>
      <button
        *ngIf="buttonIsShow"
        class="bg-yellow-gold-dark md:h-12 w-full tracking-widest rounded-lg"
        mat-flat-button
        color="primary"
        (click)="gotoStripeClick.emit({ planId })"
        [disabled]="buttonDisabled"
      >
        {{ buttonText }}
      </button>
      <div
        *ngIf="badge"
        class="whitespace-pre-line text-white absolute -top-6 -right-6 size-16 rounded-full flex items-center justify-center font-bold tracking-widest leading-4"
        [ngClass]="{
          'bg-primary': badge === '期間\n限定',
          'bg-yellow-gold-dark': badge === 'おトク!'
        }"
      >
        {{ badge }}
      </div>
    </div>
  </div>
</ng-template>

<!-- ***************************************************** -->
<!-- 入試直前 -->
<!--<div class="flex flex-col lg:flex-row gap-6 lg:gap-8">-->
<!--  &lt;!&ndash; 3ヶ月プランのカード &ndash;&gt;-->
<!--  <ng-container-->
<!--    *ngTemplateOutlet="-->
<!--      cardTemplate;-->
<!--      context: {-->
<!--        highlight: true,-->
<!--        title: '＼ 入試直前に! ／',-->
<!--        plan: 3,-->
<!--        price: '3,500',-->
<!--        period: '2026年3月25日までの限定販売！',-->
<!--        duration: '92日間',-->
<!--        badge: '期間\n限定',-->
<!--        buttonText: '購入画面へ',-->
<!--        buttonIsShow: buttonIsShow,-->
<!--        buttonDisabled: buttonDisabled,-->
<!--        monthlyPrice: null,-->
<!--        planId: shortTerm3MonthsPlan.id-->
<!--      }-->
<!--    "-->
<!--  ></ng-container>-->

<!--  &lt;!&ndash; 6ヶ月プランのカード &ndash;&gt;-->
<!--  <ng-container-->
<!--    *ngTemplateOutlet="-->
<!--      cardTemplate;-->
<!--      context: {-->
<!--        highlight: false,-->
<!--        title: '＼ じっくり準備したい方に ／',-->
<!--        plan: 6,-->
<!--        price: '6,600',-->
<!--        period: null,-->
<!--        duration: '183日間',-->
<!--        badge: null,-->
<!--        buttonText: '購入画面へ',-->
<!--        buttonIsShow: buttonIsShow,-->
<!--        buttonDisabled: buttonDisabled,-->
<!--        monthlyPrice: '1100',-->
<!--        planId: biannualPlan.id-->
<!--      }-->
<!--    "-->
<!--  ></ng-container>-->

<!--  &lt;!&ndash; 12ヶ月プランのカード &ndash;&gt;-->
<!--  <ng-container-->
<!--    *ngTemplateOutlet="-->
<!--      cardTemplate;-->
<!--      context: {-->
<!--        highlight: false,-->
<!--        title: '＼ 1年を通して学習したい方に ／',-->
<!--        plan: 12,-->
<!--        price: '8,800',-->
<!--        period: null,-->
<!--        duration: '365日間',-->
<!--        badge: 'おトク!',-->
<!--        buttonText: '購入画面へ',-->
<!--        buttonIsShow: buttonIsShow,-->
<!--        buttonDisabled: buttonDisabled,-->
<!--        monthlyPrice: '733',-->
<!--        planId: annualPlan.id-->
<!--      }-->
<!--    "-->
<!--  ></ng-container>-->
<!--</div>-->

<!-- ***************************************************** -->
<!-- デフォルト -->
<!--<app-alert-box *ngIf="showPriceRevisionNotice" type="info" [closeable]="false" alignItems="flex-start" class="block mb-6 max-w-3xl mx-auto">-->
<!--  <div class="text-sm leading-relaxed space-y-2">-->
<!--    <div>-->
<!--      <strong>2026年7月30日（木）より価格改定を予定しています。</strong><br />-->
<!--      6か月プラン ¥5,500→¥6,600（税込）／12か月プラン ¥7,700→¥8,800（税込）-->
<!--    </div>-->
<!--    <div>-->
<!--      コスト高騰により現行価格の維持が困難な状況に鑑み、サービスの安定提供と品質向上を最優先に考え、価格を改定する運びとなりました。-->
<!--    </div>-->
<!--    <div>※価格改定前に購入したプランは、有効期限満了まで追加料金なしでご利用いただけます。</div>-->
<!--  </div>-->
<!--</app-alert-box>-->

<div class="flex flex-col lg:flex-row gap-6 lg:gap-8">
  <!-- 6ヶ月プランのカード -->
  <ng-container
    *ngTemplateOutlet="
      cardTemplate;
      context: {
        highlight: false,
        title: '＼ じっくり準備したい方に ／',
        plan: 6,
        price: '6,600',
        period: null,
        duration: '183日間',
        badge: null,
        buttonText: '購入画面へ',
        buttonIsShow: buttonIsShow,
        buttonDisabled: buttonDisabled,
        monthlyPrice: '1,100',
        planId: biannualPlan.id
      }
    "
  ></ng-container>

  <!-- 12ヶ月プランのカード -->
  <ng-container
    *ngTemplateOutlet="
      cardTemplate;
      context: {
        highlight: false,
        title: '＼ 1年を通して学習したい方に ／',
        plan: 12,
        price: '8,800',
        period: null,
        duration: '365日間',
        badge: 'おトク!',
        buttonText: '購入画面へ',
        buttonIsShow: buttonIsShow,
        buttonDisabled: buttonDisabled,
        monthlyPrice: '733',
        planId: annualPlan.id
      }
    "
  ></ng-container>
</div>
